export const styles = require('./styles.module.css')